module.exports = __webpack_public_path__ + "img/icon_光圈@2x.e8f4ad5b.png";